import { ICandidateProfessionalEntity, IGetCandidateProfessionalApiResponse } from '../types';

const toGetCandidateProfessionalEntity = ({
  data,
}: IGetCandidateProfessionalApiResponse): ICandidateProfessionalEntity => {
  return {
    id: data.id,
    isShortlisted: data.isShortlisted,
    officeStatus: data.officeStatus,
  };
};

export const CandidateProfessionalAdapters = {
  toGetCandidateProfessionalEntity,
};
